module.exports = __webpack_public_path__ + "assets/img/face_check_example4.e661824f.png";